import { render, staticRenderFns } from "./rejections.vue?vue&type=template&id=d2f7bd60&scoped=true&lang=html&"
import script from "./rejections.vue?vue&type=script&lang=js&"
export * from "./rejections.vue?vue&type=script&lang=js&"
import style0 from "./rejections.vue?vue&type=style&index=0&id=d2f7bd60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f7bd60",
  null
  
)

export default component.exports